const items = [
  "2D Floor Plans",
  "3D Renderings",
  "Renew Old Plans",
  "DC · MD · VA",
  "Drawn with care",
];

const dots = ["bg-amber-400", "bg-rose-400", "bg-teal-400", "bg-sky-400"];

export default function Marquee() {
  return (
    <div
      className="bg-stone-900 text-white overflow-hidden py-6"
      data-testid="marquee"
    >
      <div className="flex animate-ticker whitespace-nowrap">
        {[...items, ...items, ...items, ...items].map((item, idx) => (
          <div
            key={`${item}-${idx}`}
            className="flex items-center gap-8 px-8 font-display text-lg sm:text-xl font-medium"
          >
            <span>{item}</span>
            <span className={`h-2.5 w-2.5 rounded-full ${dots[idx % dots.length]}`} />
          </div>
        ))}
      </div>
    </div>
  );
}
